import { get } from './client.js';

export const getWorkspaceRuntime = (wsId) => get(`/workspaces/${wsId}/runtime`);
